import { isNil } from "es-toolkit/compat";

export const toQueryString = (
    payload: Record<string, string | number | boolean | null | undefined>,
): `?${string}` => {
    return `?${Object.keys(payload)
        .map((key) => {
            const value = payload[key];
            return isNil(value) || value === ""
                ? undefined
                : `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        })
        .filter((value) => !!value)
        .join("&")}`;
};
